import store from './store'
import Firebase from 'firebase'

const config = {
  apiKey: "AIzaSyDQCI-MXE7IxEW-VO7eZ0JO70VDMLA8ZuU",
  authDomain: "thwacktrack.firebaseapp.com",
  databaseURL: "https://thwacktrack.firebaseio.com",
  projectId: "thwacktrack",
  storageBucket: "thwacktrack.appspot.com",
  messagingSenderId: "964878352400",
}

export default {
  install: (Vue, options) => {
    const firebase = Firebase.initializeApp(config)
    const auth = firebase.auth()

    Vue.prototype.$auth = {
      signup: async (username, pass) => {
        return await auth.createUserWithEmailAndPassword(username, pass)
      },
      login: async (username, pass) => {
        return await auth.signInWithEmailAndPassword(username, pass)
      },
      logout: async () => {
        await auth.signOut()
      }
    }
    auth.onAuthStateChanged(user => {
      store.commit('updateUser', { user })
    })
  }
}


// WEBPACK FOOTER //
// ./src/FirebaseAuthPlugin.js